import { Assessment, AssessmentOutlined, BusinessOutlined, Campaign, LocationOnOutlined, People, PeopleAlt, PeopleAltOutlined, Person4Outlined, PersonOutlined, Smartphone } from "@mui/icons-material"



const banquetOnboardingContent = {
    title: "Welcome to Banquet First",
    subTitle: "Set up your company, venue, and team in minutes with our streamlined onboarding process",
    cards: [
        {
            title: "Banquets Setup",  
            subTitle: "Create your banquet profile with logo and details",
            icon: BusinessOutlined
        },  
        {
            title: "Venue Management",  
            subTitle: "Add and manage your venue",
            icon: LocationOnOutlined
        },
        {
            title: "User Profiles",
            subTitle: "Complete user registration and setup",
            icon: PeopleAltOutlined
        }
    ]
}


// const talkvitOnboardingContent = {
//     title: "Welcome to Your Platform",
//     subTitle: "Set up your campaigns, contacts, and team in minutes with our streamlined onboarding process",
//     cards: [
//         {
//             title: "Campaign Setup",  
//             subTitle: "Create and schedule your WhatsApp campaigns with templates and automation",
//             icon: Campaign
//         },  
//         // {
//         //     title: "Contact Management",  
//         //     subTitle: "Import and organize your contact lists and segments",
//         //     icon: "PersonAddOutlined"
//         // },
//         {
//             title: "User Profiles",
//             subTitle: "Complete user registration and setup",
//             icon: PeopleAltOutlined
//         },
//         {
//             title: "Analytics & Reports",
//             subTitle: "Track your campaign performance with detailed reports",
//             icon: AssessmentOutlined
//         }
//     ]
// }

const talkvitOnboardingContent = {
  title: "Welcome to Talkvit",
  subTitle:
    "Set up your Account, Company, and team in minutes with our streamlined onboarding process",
  cards: [
    {
      title: "Mobile Verification",
      subTitle: "Verify your phone number with a quick OTP to secure your account",
      icon: Smartphone,
    },
    {
      title: "Company Setup",
      subTitle: "Add your company details, location, and branding information",
      icon: BusinessOutlined,
    },
    {
      title: "User Profiles",
      subTitle: "Complete user registration and setup",
      icon: PeopleAltOutlined,
    },
  ],
};

export const landingPageContent = {
    BANQUET_FIRST: banquetOnboardingContent,
    TALKVIT: talkvitOnboardingContent
}